import {
  type IHotelInfoRouteParamName,
  hotelInfoRouteParamNames,
  HOTEL_INFO_ROUTE_PATH,
} from "@modules/hotel-info-path";

export type IConfirmationParamName = "tripKey" | IHotelInfoRouteParamName;
export const confirmationParamNames: SameRecord<IConfirmationParamName> = {
  tripKey: "tripKey",
  ...hotelInfoRouteParamNames,
};
export const CONFIRMATION_PATH = `${HOTEL_INFO_ROUTE_PATH}/confirmation/:${confirmationParamNames.tripKey}`;

export type IConfirmationSearchParamName = "fromCheckout" | "requestReview";
export const confirmationSearchParamNames: SameRecord<IConfirmationSearchParamName> = {
  fromCheckout: "fromCheckout",
  requestReview: "requestReview",
};
